import { Icon } from '@livable/saas-react-components';
import { FormControl, InputAdornment, InputLabel, OutlinedInput } from '@mui/material';
import React from 'react';
import RangeDatePicker from 'src/components/general/RangeDatePicker';
import useStyles from './billDetailsStyles';
import { formatMoney } from './billDetailsUtils';
const CAD_HINT = 'The common area deduction comes from the property settings.';
function ExtractedHint(_ref) {
  let value = _ref.value;
  const classes = useStyles();
  return /*#__PURE__*/React.createElement("span", {
    className: classes.extractedHint
  }, "Extracted:", /*#__PURE__*/React.createElement("span", {
    className: classes.extractedHintChip
  }, value));
}

/**
 * Allocation inputs for one property/utility (Figma: allocation table, edit state). Changes are
 * reported immediately, so the deductions, total billing and per-unit charges follow along.
 */
export function AllocationEditForm(_ref2) {
  var _ref3, _setting$billAmount, _setting$gwdPercent;
  let currency = _ref2.currency,
    onChange = _ref2.onChange,
    setting = _ref2.setting,
    utility = _ref2.utility;
  const classes = useStyles();
  return /*#__PURE__*/React.createElement("div", {
    className: classes.allocationEditForm
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.allocationEditRow
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.allocationEditField
  }, /*#__PURE__*/React.createElement(RangeDatePicker, {
    format: "MM/dd/yy",
    fromDate: utility.serviceStartDate || '',
    handleDateChange: dates => onChange({
      serviceEndDate: dates.endDate,
      serviceStartDate: dates.startDate
    }),
    label: "Service dates",
    noValidate: true,
    toDate: utility.serviceEndDate || ''
  }), /*#__PURE__*/React.createElement(ExtractedHint, {
    value: utility.extractedPeriod
  })), /*#__PURE__*/React.createElement("div", {
    className: classes.allocationEditField
  }, /*#__PURE__*/React.createElement(FormControl, {
    fullWidth: true,
    variant: "outlined"
  }, /*#__PURE__*/React.createElement(InputLabel, {
    htmlFor: "bill-amount-".concat(utility.serviceType)
  }, "Bill amount"), /*#__PURE__*/React.createElement(OutlinedInput, {
    id: "bill-amount-".concat(utility.serviceType),
    label: "Bill amount",
    onChange: event => onChange({
      billAmount: event.target.value
    }),
    startAdornment: /*#__PURE__*/React.createElement(InputAdornment, {
      position: "start"
    }, "$"),
    value: (_ref3 = (_setting$billAmount = setting.billAmount) !== null && _setting$billAmount !== void 0 ? _setting$billAmount : utility.extractedAmount) !== null && _ref3 !== void 0 ? _ref3 : ''
  })), /*#__PURE__*/React.createElement(ExtractedHint, {
    value: formatMoney(utility.extractedAmount, currency)
  }))), /*#__PURE__*/React.createElement("div", {
    className: classes.deductions
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.sectionLabel
  }, "Deductions"), /*#__PURE__*/React.createElement("div", {
    className: classes.deductionRow
  }, /*#__PURE__*/React.createElement("span", {
    className: classes.deductionLabel
  }, "Common Area Deduction (CAD): ", /*#__PURE__*/React.createElement("span", {
    className: classes.deductionValue
  }, utility.cadPercent, "%")), /*#__PURE__*/React.createElement("span", {
    className: classes.deductionLocked,
    title: CAD_HINT
  }, /*#__PURE__*/React.createElement(Icon, {
    state: "grey",
    type: "lock-locked"
  }), "Locked")), /*#__PURE__*/React.createElement("div", {
    className: classes.deductionRow
  }, /*#__PURE__*/React.createElement("span", {
    className: classes.deductionLabel
  }, "Good Will Deduction (GWD):"), /*#__PURE__*/React.createElement(OutlinedInput, {
    className: classes.deductionInput,
    endAdornment: /*#__PURE__*/React.createElement(InputAdornment, {
      position: "end"
    }, "%"),
    inputProps: {
      'aria-label': 'Good will deduction percent',
      max: 100,
      min: 0,
      type: 'number'
    },
    onChange: event => onChange({
      gwdPercent: event.target.value
    }),
    value: (_setting$gwdPercent = setting.gwdPercent) !== null && _setting$gwdPercent !== void 0 ? _setting$gwdPercent : utility.gwdPercent
  }))));
}